import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import { SignIn, SignUp } from "@clerk/react";
import "@/App.css";
import ClerkAuthProvider from "@/components/auth/ClerkAuthProvider";
import Home from "@/pages/Home";

const AuthPage = ({ children }) => (
  <div className="rs-root flex flex-col items-center justify-center gap-6 px-4 py-10">
    <Link to="/" className="rs-secondary text-[15px]" data-testid="auth-back-link">← Back to Recipe Remedy</Link>
    {children}
  </div>
);

export default function App() {
  return (
    <BrowserRouter>
      <ClerkAuthProvider>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/sign-in/*" element={<AuthPage><SignIn routing="path" path="/sign-in" signUpUrl="/sign-up" withSignUp /></AuthPage>} />
          <Route path="/sign-up/*" element={<AuthPage><SignUp routing="path" path="/sign-up" signInUrl="/sign-in" /></AuthPage>} />
        </Routes>
      </ClerkAuthProvider>
    </BrowserRouter>
  );
}
